import { render } from "./file-drag-and-drop.html?vue&type=template&id=09e64137&scoped=true&ts=true&external"
import script from "./file-drag-and-drop.ts?vue&type=script&lang=ts&external"
export * from "./file-drag-and-drop.ts?vue&type=script&lang=ts&external"

import "./file-drag-and-drop.scss?vue&type=style&index=0&id=09e64137&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e64137"]])

export default __exports__